import { useState, useEffect } from "react";
import { TenantQuery, useTenantLazyQuery } from "v3/services/graphql/generated";
import client from "v3/services/graphql";

export interface TenantContextInterface {
  tenant: TenantQuery["tenant"];
}

export function useTenantProvider(): {
  tenantContextValue: TenantContextInterface;
} {
  const [tenant, setTenant] = useState<TenantQuery["tenant"] | null>(null);
  const [getTenant] = useTenantLazyQuery({ client });

  useEffect(() => {
    const handleGetTenant = async () => {
      const { data } = await getTenant();
      if (data?.tenant) setTenant(data.tenant);
    };
    if (!tenant) handleGetTenant();
  }, [tenant, getTenant]);

  const tenantContextValue: TenantContextInterface = {
    tenant,
  };

  return { tenantContextValue };
}
